import React, { useState } from "react";
import Swal from "sweetalert2";

const OrderSummary = ({
  cartItems,
  user,
  selectedCoupon,
  setSelectedCoupon,
  handleApplyCoupon,
  isApplying,
  loading,
  couponMessage,
  handleSubmit,
  handleRemoveCoupon,
  setIsConsentCheckedprop,
}) => {
  const [isConsentChecked, setIsConsentChecked] = useState(false);

  const activeItem = cartItems && cartItems.length > 0 ? cartItems[0] : null;
  const activeCoupon = activeItem?.coupon;

  const displayFinalTotal = activeItem?.final_price || "0.00";
  const displayOriginalTotal = activeItem?.total_price || "0.00";
  const displayDiscountAmount = activeItem?.discount_amount || "0.00";
  const hasDiscount = parseFloat(displayDiscountAmount) > 0;

  const handleCheckoutClick = () => {
    if (!isConsentChecked) {
      Swal.fire({
        icon: "warning",
        title: "Consent Required",
        text: "You must accept the Refund Policy and Parent/Guardian Consent before checkout.",
      });
      return;
    }
    handleSubmit();
  };

  return (
    <div className="checkout-card summary-section brightness">
      <div className="summary-header">
        <span className="header-gold text-clip" style={{ flex: 1.5 }}>
          SUMMER CAMP
        </span>
        <span className="header-gold text-clip" style={{ flex: 3 }}>
          DESCRIPTION & PLAYERS
        </span>
        <span
          className="header-gold text-clip"
          style={{ flex: 1, textAlign: "right" }}
        >
          TOTAL
        </span>
      </div>
      <div className="divider"></div>

      {cartItems.map((item) => (
        <div key={item.id} className="summary-item-row">
          <div className="summary-col col-name">
            <span className="item-title text-clip">
              {item.offering?.name || "Summer Camp"}
            </span>
            <div className="item-subtitle-group">
              <span className="badge-year">{item.offering?.year}</span>
              <span className="item-subtitle text-clip">
                Type: {item.offering?.offering_type?.replace("_", " ")}
              </span>
            </div>
          </div>

          <div className="summary-col col-desc">
            <div className="desc-text">
              <strong className="text-clip">About: </strong>
              <span className="text-clip">
                {item.offering?.description?.replace(/"/g, "") || "N/A"}
              </span>
            </div>

            <div className="desc-meta-row">
              <span className="meta-pill bg-custom text-clip">
                Total Players: {item.total_players}
              </span>
              <span className="meta-pill bg-custom text-clip">
                Total Weeks: {item.total_weeks}
              </span>
            </div>
          </div>

          <div className="summary-col col-price">
            <span className="price-tag text-clip">
              ${parseFloat(item.total_price).toFixed(2)}
            </span>
          </div>
        </div>
      ))}

      <div className="coupon-wrapper-new">
        <div className="coupon-label-side text-clip">Apply Coupon</div>
        <div className="coupon-input-side">
          <input
            type="text"
            placeholder="ENTER COUPON CODE"
            value={selectedCoupon}
            onChange={(e) => setSelectedCoupon(e.target.value)}
            className="coupon-input-clean"
          />
          <button
            onClick={handleApplyCoupon}
            disabled={!selectedCoupon || isApplying || loading}
            className="coupon-apply-btn-clean"
          >
            {isApplying ? "..." : "Apply"}
          </button>
        </div>
      </div>
      {/* activeCoupon.discount_amount is coupon value and activeItem.discount_amount is amount that will be deducted */}
      {activeCoupon && (
        <div className="coupon-success-banner">
          <span className="success-text">
            Applied: {activeCoupon.name} (
            {activeCoupon.discount_value
              ? `${activeCoupon.discount_value}%`
              : `$${activeItem?.discount_amount}`}
            )
          </span>
          <button className="remove-coupon-link" onClick={handleRemoveCoupon}>
            <span>✕ Remove</span>
          </button>
        </div>
      )}

      <div className="divider"></div>

      <div className="summary-footer-vertical">
        <div className="footer-row-main">
          <span className="header-gold total-text text-clip">TOTAL</span>
          <span className="total-price-large text-clip">
            ${parseFloat(displayFinalTotal).toFixed(2)}
          </span>
        </div>
      </div>

      {/* 🔥 CONSENT SECTION */}
      <div className="consent-container">
        <div className="consent-scroll-box">
          <h4 className="text-clip">Refund Policy</h4>
          <p className="text-clip">
            We understand that sometimes unexpected things come up! If you need
            to cancel your child’s enrollment, please note the following: All
            cancellations must be submitted at least 21 days before the camp
            start date (by June 15, 2026). A doctor’s note is required in order
            for a refund to be issued. Cancellations made after June 15, 2026
            will not be eligible for a refund. Any processing or registration
            fees are non-refundable. Approved refunds will be returned to the
            original form of payment. Because we plan staffing, space, and
            equipment well in advance, we truly appreciate your understanding
            and cooperation.
          </p>

          <h4 className="text-clip">Parent/Guardian Consent (Required)</h4>
          <p className="text-clip">
            By submitting and electronically signing this registration form, I
            acknowledge and agree to the following: I give permission for my
            child to participate in all activities, programs, and events
            operated by Shootin School and its partners. I authorize staff to
            provide basic first aid and non-emergency medical treatment if
            necessary. In the event of an accident or medical emergency, I
            authorize staff to obtain emergency medical care if I cannot be
            reached. I understand I am responsible for any medical expenses
            incurred. I release and hold harmless Shootin School and its
            affiliates from any liability arising from participation. I grant
            permission for photos/videos of my child to be used for promotional
            purposes without compensation. By clicking I ACCEPT, I confirm that
            I have read, understand, and agree to this consent, waiver, and
            release of liability in full.
          </p>
        </div>

        <label className="consent-check" style={{ marginTop: "20px" }}>
          <input
            type="checkbox"
            checked={isConsentChecked}
            onChange={(e) => {
              setIsConsentChecked(e.target.checked);
              setIsConsentCheckedprop(e.target.checked);
            }}
          />
          <span className="text-clip" style={{ fontSize: "16px" }}>
            <b>I ACCEPT</b> the Refund Policy and Parent/Guardian Consent
          </span>
        </label>
      </div>

      {!isConsentChecked && (
        <div className="form-group" style={{ marginTop: "20px" }}>
          <label className="input-label" style={{ color: "red" }}>
            *Note: You must accept the Refund Policy and Parent/Guardian Consent
            to proceed with payment.
          </label>
        </div>
      )}

      {user && (
        <button
          className={`place-order-btn ${!isConsentChecked ? "disabled-btn" : ""}`}
          onClick={handleCheckoutClick}
          disabled={!isConsentChecked || loading}
        >
          Proceed to Checkout
        </button>
      )}
    </div>
  );
};

export default OrderSummary;
